import * as React from 'react';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MuiDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Badge from '@mui/material/Badge';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Link from '@mui/material/Link';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useRef ,useState} from 'react';
import Grid from '@mui/material/Grid';
import { createSearchParams, useLocation } from "react-router-dom";
import { store } from '../helpers/store';
import { setPageLoadFinish, setPageLoading } from '../slices/page.slice';
import { fetchInvoices, invoiceItemsSelector, setInvoiceLoading, setInvoiceSearchKeyDeliverylocationumber, setInvoiceSearchKeyFromdate, setInvoiceSearchKeySaletype, setInvoiceSearchKeyTodate, setInvoiceSearchKeyNumber, setInvoiceSearchKey, clearInvoiceFilters, fetchInvoice, setSelectedInvoiceId } from "../slices/invoices.slice";
import DataGrid from 'react-data-grid';
import CircularProgress from '@mui/material/CircularProgress';
import LinearProgress from '@mui/material/LinearProgress';
import Checkbox from '@mui/material/Checkbox';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { pink } from '@mui/material/colors';
import SvgIcon from '@mui/material/SvgIcon';
import DehazeIcon from '@mui/icons-material/Dehaze';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import IconButton from '@mui/material/IconButton';
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import TextField from '@mui/material/TextField';
import DatePicker from "react-multi-date-picker"
import { Calendar } from "react-multi-date-picker"
import moment from 'jalali-moment'
import Tooltip from '@mui/material/Tooltip';
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import JalaliUtils from "@date-io/jalaali";
import SearchIcon from '@mui/icons-material/Search';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import Modal from "@material-ui/core/Modal";
import { useNavigate } from "react-router-dom";
import { clearAccountReviewFilters, fetchAccountReview, setAccountReviewSearchKeyFromdate, setAccountReviewSearchKeyTodate, setAccountReviewsearchKey, setAccountReviewsearchKeyCredit, setAccountReviewsearchKeyDebit, setAccountReviewsearchKeyFromdate, setAccountReviewsearchKeyTodate, setAccountReviewsearchKeyType } from '../slices/accountReview.slice';
import { SpatialTrackingSharp } from '@mui/icons-material';
import { FormControlLabel } from '@mui/material';


export const zeroPad = (num, places) => String(num).padStart(places, '0');




export const AccountReview = () => {
  const dispatch = useDispatch();
  //const { user: authUser } = useSelector(x => x.auth);
  const authUser = JSON.parse(localStorage.getItem('user'));

  const accountReview = useSelector(x => x.accountReview);
  const defaultValues1 = useSelector(x => x.defaultValue);
  const defaultValues = JSON.parse(localStorage.getItem('defaultValue'));

  let navigate = useNavigate();
 


const columns = [
  {
    name: 'ردیف',
    key: 'rowIndex',
    width: '1%',
  }, 
  {
    key: 'VoucherDate',
    name: 'تاریخ',
    width: '10%',
    resizable: true,
    sortable: true
  },
  {
    key: '',
    name: 'مبلغ',
    width: '15%',
    resizable: true,
    sortable: true,
    formatter(props) {
      

      if(props.row.Debit_sh !== '0' && props.row.Debit_sh !== ''){
        return  <span style={{ color : '#43A047' }}>{props.row.Debit_sh}+</span>;
      }else if(props.row.Credit_sh !== '0' && props.row.Credit_sh !== ''){
        return  <span style={{ color : '#E53935' }}>{props.row.Credit_sh}-</span>;
      }
     
    },

  },
  {
    key: 'RunningValue',
    name: 'مانده در خط',
    width: '15%',
    resizable: true,
    sortable: true,
    
    formatter(props) {
      //if(props.row.)
      if(props.row.RunningValue.toString().includes("(")){
        return  <span style={{ color : '#E53935' }}>{props.row.RunningValue}</span>;
      }else{
        return  <span>{props.row.RunningValue}</span>;
      }

    },
  },
  {
    key: 'Description',
    name: 'شرح',
    width: '59%',
    resizable: true,
    sortable: true
  }
];


   useEffect(() => {
      //console.log("useEffect"); 
      //console.log("currentPageIndex"); 
      //console.log(invoices.currentPageIndex); 
      
      //dispatch(setLoading());
      if(accountReview.fetchPermission){
        dispatch(fetchAccountReview({hasMore: true, pageindex: 0 , searchKey : accountReview.searchKey , searchKey_debit : accountReview.searchKey_debit, searchKey_credit : accountReview.searchKey_credit , fromdate: defaultValues.FiscalYearStartDate , todate :  defaultValues.FiscalYearEndDate , customerRemainAmount : defaultValues.CustomerSaleAndFinancialDataModel.a8 , authUser}));

      }

   }, []);


   const handleChange = (e , changingItemType, props , value) => {
  
    //console.log(e.target);
    //console.log(props.row);//SelectedRow
    //console.log("Handle Checkbx change");
    switch(changingItemType) {
      case 'unitTitle':
        // code block
        //console.log(props.row.Number);
        break;
      case 'number':
        console.log("Value is "+ value);
   
        //navigate('/invoice');
        
        //dispatch(setSelectedInvoiceId(value));

        //این اوکیه
        //navigate({ pathname : '/invoice' , search : createSearchParams({
        //    entityId : value
        //}).toString()});
      
       
       
        break;
      default:
        // code block
    }
  
  }
  
  function rowKeyGetter(row) {
    return row.ID;
  }

  
   async function handleScroll(event) {
    if (accountReview.loading || !isAtBottom(event)) return;


    await loadMoreRows();

    //setRows([...rows, ...newRows]);
    //setIsLoading(false);
  }
  function EmptyRowsRenderer() {
    return (
    
      <div style={{ textAlign: 'center', gridColumn: '1/-1' }}>
        {accountReview.loading ? '' :   ' اطلاعاتی برای نمایش وجود ندارد' }
      </div>
    );
  }
  function isAtBottom({ currentTarget }) {
    if(currentTarget.scrollTop + 10 >= currentTarget.scrollHeight - currentTarget.clientHeight){
        //console.log("isAtBottom");
        
    }
    return currentTarget.scrollTop + 10 >= currentTarget.scrollHeight - currentTarget.clientHeight;
  }
  
const onFromDateSelectedHandler = (e) =>{
  var day = zeroPad(e.day , 2);
  var month = zeroPad(e.month.number , 2);
  var year = e.year;

  dispatch(setAccountReviewsearchKeyFromdate(year + "/" + month + "/"+ day));
  
}
const onToDateSelectedHandler = (e) =>{
  var day = zeroPad(e.day , 2);
  var month = zeroPad(e.month.number , 2);
  var year = e.year;
  dispatch(setAccountReviewsearchKeyTodate(year + "/" + month + "/"+ day));
}
const onSearchChange = (e) =>{

  dispatch(setAccountReviewsearchKey(e.target.value));
}

const onDebitChecked = (e) =>{
  console.log(e.target.checked);
  if(e.target.checked){
    dispatch(setAccountReviewsearchKeyDebit(1));
  }
  else{
    dispatch(setAccountReviewsearchKeyDebit(2));
  }
}
const onCreditChecked = (e) =>{
  console.log(e.target.checked);
  if(e.target.checked){
    dispatch(setAccountReviewsearchKeyCredit(1));
  }else{
    dispatch(setAccountReviewsearchKeyCredit(2));
  }
 
}

  function loadMoreRows() {
    //console.log("currentPageIndex for load more"); 
    ///dispatch(setLoading());
    dispatch(fetchAccountReview({hasMore: accountReview.hasMore, pageindex: accountReview.currentPageIndex , searchKey : accountReview.searchKey , searchKey_debit : accountReview.searchKey_debit, searchKey_credit : accountReview.searchKey_credit , fromdate: (accountReview.searchKey_fromdate === '' ? defaultValues.FiscalYearStartDate : accountReview.searchKey_fromdate), todate : (accountReview.searchKey_todate === '' ?defaultValues.FiscalYearEndDate : accountReview.searchKey_todate ) , customerRemainAmount : defaultValues.CustomerSaleAndFinancialDataModel.a8 , authUser}));
  }

  
   let dataSource  = [];

   if(accountReview.items !== undefined && accountReview.items.length > 0)
   {
       dataSource = accountReview.items.map((item, i) => ({...item, rowIndex : i+1}));
   }
   const dynamicHeight = Math.min(accountReview.items.length * 6 + 20, 75) + 'vh';

   const mdTheme = createTheme({
    typography: {
      fontFamily: [
        "mohammadfont",
        "Tahoma",
        "Verdana"
      ].join(",")
    },
    direction: 'rtl',
    components: {
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            backgroundColor: '#FBC02D',
            color: '#424242'
          },
        },
      },
    }
  });

const onSearchHandler = (e) =>{

  dispatch(fetchAccountReview({hasMore: true, pageindex: 0 , searchKey : accountReview.searchKey , searchKey_debit : accountReview.searchKey_debit, searchKey_credit : accountReview.searchKey_credit , fromdate: (accountReview.searchKey_fromdate === '' ? defaultValues.FiscalYearStartDate : accountReview.searchKey_fromdate), todate : (accountReview.searchKey_todate === '' ?defaultValues.FiscalYearEndDate : accountReview.searchKey_todate ) , customerRemainAmount : defaultValues.CustomerSaleAndFinancialDataModel.a8, authUser}));

}

const onClearFilterHandler = (e) =>{

  dispatch(clearAccountReviewFilters());

}




  return (
    <>

<ThemeProvider theme={mdTheme}>

<Box sx={{ flexGrow: 1 }}>
     
     <Grid container>
              <Grid item xs={12}>
                       
                        <Accordion>
                <AccordionSummary
                  expandIcon={<FilterAltIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                <Typography sx={{ width: '33%', flexShrink: 0 }}>
            گردش حساب من
          </Typography>
          <Typography sx={{ color: 'text.secondary' }}>برای جستجو کلیک کنید</Typography>

                </AccordionSummary>
                <AccordionDetails>
                <span className='fontSize14'>
                  جستجو &nbsp;&nbsp;
              </span>
              &nbsp;&nbsp;
              <TextField value={accountReview.searchKey} size="small" label="عبارت جستجو" variant="outlined" onChange={onSearchChange} />
              &nbsp;&nbsp;
              <FormControlLabel
                control={
                  <Checkbox checked={accountReview.searchKey_debit === 1 ? true : false} onChange={onDebitChecked}/>

                }
                label="بدهکار"
              />
                &nbsp;&nbsp;
              <FormControlLabel
                control={
                  <Checkbox checked={accountReview.searchKey_credit === 1 ? true : false} onChange={onCreditChecked} />

                }
                label="بستانکار"
              />
              &nbsp;&nbsp;
              <span className='fontSize14'>
                  از:
              </span>
                  <DatePicker value={accountReview.searchKey_fromdate}
                              onChange={onFromDateSelectedHandler}
                              calendar={persian}
                              locale={persian_fa}
                              animation="true"
                              inputClass="dateCss" style = {{width: 100}}
                            />
                  <span className='fontSize14'>
                  تا:
              </span>
                  <DatePicker value={accountReview.searchKey_todate}
                              onChange={onToDateSelectedHandler}
                              calendar={persian}
                              locale={persian_fa}
                              animation="true"
                              inputClass="dateCss" style = {{width: 100}}
                            />
                            <Tooltip arrow followCursor title="جستجو">
                            <IconButton onClick={onSearchHandler}>
                    <SearchIcon sx={{ color: '#2979FF' }}/>
                  </IconButton>
                </Tooltip>
                <Tooltip arrow followCursor title="حذف فیلترها">
                                          <IconButton onClick={onClearFilterHandler}>
                                  <FilterAltOffIcon sx={{ color: '#F44336' }}/>
                                </IconButton>
                </Tooltip>
                </AccordionDetails>
          </Accordion>
             </Grid>
     </Grid>
     </Box>
  <DataGrid 
    renderers={{ noRowsFallback: <EmptyRowsRenderer /> }}
    direction="rtl" 
    columns={columns} 
    rows={dataSource} 
    rowKeyGetter={rowKeyGetter}
    onScroll={handleScroll}
    style={{height : dynamicHeight}}
    rowClass={(row) => (row.Description.includes('مانده قبل از دوره') ? 'tablehighlightClassname' : undefined)}
    />

    

    {accountReview.loading ?   <div className="LoadingDiv">در حال دریافت اطلاعات <LinearProgress color="inherit" /></div>: "" }

    </ThemeProvider>
    </>
  );
}

export default AccountReview;